// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import maskInput from '../../../../utils/maskInput';
import DateRangePicker from '../../../common/DateRangePicker';
import { trimCommas } from '../../../../utils/commonUtils';
import dayjs from 'dayjs';
import formatNumberWithCommas from '../../../../helpers/numberWithCommasHelper';

export default class FormView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.simple_form');

    this.render();
    this.renderInvestmentArea();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs()
          .add(10, 'years')
          .toDate(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'change', selector: 'input, select' })
  changeInput() {
    $('.cancel-button').each(function() {
      const cancelButton = $(this);
      const newButton = $(
        '<button type="button" class="btn btn-outline-link" data-toggle="modal" data-target="#cancelModal">キャンセル</button>',
      );

      cancelButton.replaceWith(newButton);
    });
  }

  @on({ event: 'click', selector: 'input[type="submit"]' })
  trimCommasFromValue() {
    $('.currency').each(function() {
      const input = $(this);
      input.val(trimCommas(input.val()));
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    target.toggleClass('form-control-active', target.val().length !== 0);
    target.removeClass('is-invalid');
    removeInvalidFeedback(target);
    target.removeClass('focus');
  }

  @on({ event: 'click', selector: '.show_remove_modal' })
  onClickShowRemoveModal(event: any) {
    const fieldSet = $(event.target).parents('fieldset');

    // 削除対象用のclassが付いているものがあればclassを削除する
    $('.remove_target').removeClass('remove_target');

    // 現在の削除対象に削除対象を判別するclassをつける
    fieldSet.addClass('remove_target');
    const addText = fieldSet.find('.investment-title').val();
    $('#removeTargetInvestmentTitle').text(`『${addText}』`);
  }

  @on({ event: 'click', selector: '.remove-investment-button' })
  onClickRemoveInvestmentBtn() {
    const fieldSet = $('.remove_target');
    const _destroy = fieldSet.find('._destroy');
    _destroy.val('1');
    fieldSet.hide();
    this.disabledShowRemoveModalButton();
    this.renderInvestmentArea();

    // 削除対象用のclassを削除する
    fieldSet.removeClass('remove_target');

    $('#removeTargetInvestmentTitle').text('');
  }

  @on({ event: 'click', selector: '.js-add-investment-button' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.add-investments-wrapper').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderInvestmentArea();

    const fieldSets = $('fieldset:visible');
    const investmentCount = fieldSets.length;
    const lastInvestmentTitle = fieldSets.last().find('.investment-title');
    lastInvestmentTitle.val(`投資${investmentCount}回目`);

    this.render();
  }

  @on({ event: 'click', selector: '.js-add-staff-button' })
  addSubStaffFields(event: any) {
    const addStaffButton = $(event.target);
    const subStaffFields = addStaffButton
      .parents('fieldset')
      .find('.sub_user_company_fields');
    const subStaffInput = subStaffFields.find('select');
    event.preventDefault();

    addStaffButton.addClass('d-none');
    subStaffFields.removeClass('d-none');
    subStaffInput.prop('disabled', false);

    this.filterSubUserCompanyOptions(event);
  }

  @on({ event: 'click', selector: '.remove-staff-button' })
  removeSubStaffFields(event: any) {
    const removeStaffButton = $(event.target);
    const addStaffButton = removeStaffButton
      .parents('fieldset')
      .find('.js-add-staff-button');
    const subStaffFields = removeStaffButton
      .parents('fieldset')
      .find('.sub_user_company_fields');
    const subStaffInput = subStaffFields.find('select');
    const userCompanyOptions = removeStaffButton
      .parents('fieldset')
      .find('.user_company_id option');
    const subUserCompanyFields = removeStaffButton
      .parents('fieldset')
      .find('.sub_user_company_id');
    event.preventDefault();

    addStaffButton.removeClass('d-none');
    subStaffFields.addClass('d-none');
    subStaffInput.prop('disabled', true);

    userCompanyOptions.each(function() {
      $(this).show();
    });
    subUserCompanyFields.val(null);
  }

  @on({ event: 'input', selector: '.memo_fields textarea' })
  setMemoFields(event: any) {
    const memoInput = $(event.target);
    const memoLengthPreview = memoInput
      .parents('.memo_fields')
      .find('.memo-length-preview');
    const memoInputLength = memoInput.val().length;

    memoLengthPreview.text(memoInputLength);

    if (memoInputLength >= 0 && 1000 >= memoInputLength) {
      memoLengthPreview.removeClass('danger');
    } else {
      memoLengthPreview.addClass('danger');
    }
  }

  @on({ event: 'change', selector: '.stock-type' })
  onChangeStockType(event: any) {
    const fieldSet = $(event.target).parents('fieldset');
    const selectedStockType = fieldSet
      .find('.stock_type_fields select option:selected')
      .text();

    switch (selectedStockType) {
      case '普通株式':
        fieldSet.find('.ordinary_share_fields').removeClass('d-none');
        fieldSet
          .find('.ordinary_share_fields input:not(.stock_price)')
          .removeAttr('disabled');
        fieldSet
          .find('.class_share_fields, .convertible_equity_fields')
          .addClass('d-none');
        fieldSet
          .find('.class_share_fields input, .convertible_equity_fields input')
          .attr('disabled', 'disabled');
        break;
      case '種類株式':
        fieldSet.find('.class_share_fields').removeClass('d-none');
        fieldSet
          .find('.class_share_fields input:not(.stock_price)')
          .removeAttr('disabled');
        fieldSet
          .find('.ordinary_share_fields, .convertible_equity_fields')
          .addClass('d-none');
        fieldSet
          .find(
            '.ordinary_share_fields input, .convertible_equity_fields input',
          )
          .attr('disabled', 'disabled');
        break;
      case 'コンバーティブル・エクイティ':
        fieldSet.find('.convertible_equity_fields').removeClass('d-none');
        fieldSet
          .find('.convertible_equity_fields input:not(.payment_unit_price)')
          .removeAttr('disabled');
        fieldSet
          .find('.ordinary_share_fields, .class_share_fields')
          .addClass('d-none');
        fieldSet
          .find('.ordinary_share_fields input, .class_share_fields input')
          .attr('disabled', 'disabled');
        break;
      default:
        fieldSet
          .find(
            '.ordinary_share_fields, .class_share_fields, .convertible_equity_fields',
          )
          .addClass('d-none');
        fieldSet
          .find(
            '.ordinary_share_fields input, .class_share_fields input, .convertible_equity_fields input',
          )
          .attr('disabled', 'disabled');
        break;
    }
  }

  // 普通株式・種類株式の取得時株価の自動計算
  @on({
    event: 'input',
    selector:
      '.cal_stock_price_fields .stock_quantity, .cal_stock_price_fields .investment_amount, .cal_stock_price_fields .sale_amount',
  })
  calStockPrice(event: any) {
    const calStockPriceFields = $(event.target).parents(
      '.cal_stock_price_fields',
    );
    const stockQuantity = parseFloat(
      calStockPriceFields
        .find('.stock_quantity')
        .val()
        .replace(/,/g, '') || 0,
    );
    const targetAmount = parseFloat(
      calStockPriceFields
        .find(
          $(event.target)
            .parents('fieldset')
            .find('.js-change_status')
            .val() === 'exit'
            ? '.sale_amount'
            : '.investment_amount',
        )
        .val()
        .replace(/,/g, '') || 0,
    );

    // targetAmountが0の時・stockQuantityが0の時は、stock_priceは0
    var formatResult =
      stockQuantity === 0 || targetAmount === 0
        ? 0
        : (targetAmount / stockQuantity).toFixed(2);

    const result = formatNumberWithCommas(formatResult);

    const hiddenResult =
      stockQuantity === 0 || targetAmount === 0
        ? 0
        : targetAmount / stockQuantity;

    calStockPriceFields.find('.stock_price').val(result);
    calStockPriceFields.find('.hidden_stock_price').val(hiddenResult);
  }

  // コンバーティブル・エクイティの1個あたりの払込価格の自動計算
  @on({
    event: 'input',
    selector:
      '.cal_payment_unit_price_fields .quantity, .cal_payment_unit_price_fields .investment_amount',
  })
  calPaymentUnitPrice(event: any) {
    const calPaymentUnitPriceFields = $(event.target).parents(
      '.cal_payment_unit_price_fields',
    );
    const quantity = parseFloat(
      calPaymentUnitPriceFields
        .find('.quantity')
        .val()
        .replace(/,/g, '') || 0,
    );
    const investmentAmount = parseFloat(
      calPaymentUnitPriceFields
        .find('.investment_amount')
        .val()
        .replace(/,/g, '') || 0,
    );

    // investmentAmountが0の時・quantityが0の時は、payment_unit_priceは0
    var formatResult =
      quantity === 0 || investmentAmount === 0
        ? 0
        : (investmentAmount / quantity).toFixed(2);

    const result = formatNumberWithCommas(formatResult);

    calPaymentUnitPriceFields.find('.payment_unit_price').val(result);
  }

  initUserCompanyOptions() {
    const self = this;

    $('.user_company_id').each(function() {
      self.filterSubUserCompanyOptions($(this));
    });
    $('.sub_user_company_id').each(function() {
      self.filterUserCompanyOptions($(this));
    });
  }

  @on({ event: 'change', selector: '.user_company_id' })
  onChangeSubFilterUserCompanyOptions(event: any) {
    this.filterSubUserCompanyOptions(event.target);
  }

  filterSubUserCompanyOptions(target: any) {
    const fieldSet = $(target).parents('fieldset');
    const selectedUserId = fieldSet.find('.user_company_id').val();
    const subUserCompanyOptions = fieldSet.find('.sub_user_company_id option');

    subUserCompanyOptions.each(function() {
      if (selectedUserId && $(this).val() == selectedUserId) {
        $(this).hide();
        $(this).removeAttr('selected');
      } else {
        $(this).show();
      }
    });
  }

  @on({ event: 'change', selector: '.sub_user_company_id' })
  onChangeFilterUserCompanyOptions(event: any) {
    this.filterUserCompanyOptions(event.target);
  }

  filterUserCompanyOptions(target: any) {
    const fieldSet = $(target).parents('fieldset');
    const selectedUserId = fieldSet.find('.sub_user_company_id').val();
    const userCompanyOptions = fieldSet.find('.user_company_id option');

    userCompanyOptions.each(function() {
      if (selectedUserId && $(this).val() == selectedUserId) {
        $(this).hide();
        $(this).removeAttr('selected');
      } else {
        $(this).show();
      }
    });
  }

  renderInvestmentArea() {
    const maxInvestmentCount = 20;
    if ($('fieldset:visible').length >= maxInvestmentCount) {
      $('.js-add-investment-button').hide();
    } else {
      $('.js-add-investment-button').show();
    }
  }

  disabledShowRemoveModalButton() {
    const visibleFieldset = $('fieldset:visible');

    if (visibleFieldset.length === 1) {
      visibleFieldset.find('.show_remove_modal').hide();
    } else {
      visibleFieldset.find('.show_remove_modal').show();
    }
  }

  initMemoFieldsOptions() {
    const memoInput = $('textarea');
    const memoLengthPreview = memoInput
      .parents('.memo_fields')
      .find('.memo-length-preview');
    const memoInputLength = memoInput.val().length;

    if (memoInputLength >= 0 && 1000 >= memoInputLength) {
      memoLengthPreview.removeClass('danger');
    } else {
      memoLengthPreview.addClass('danger');
    }
  }

  @on({ event: 'change', selector: '.js-change_status' })
  onChangeStatusControl(e: any) {
    e.preventDefault();
    const status = e.target.value;
    const $target = $(e.target).parents('fieldset');

    const $statusExit = $target.find('.status_exit');
    const $statusOtherExit = $target.find('.status_other_exit');
    const $changeLabelRound = $target.find('.change-label-round');
    const $changeLabelTran = $target.find('.change-label-tran');
    const $companyInvesteeInvestmentStockType = $target.find(
      '#company_investee_investment_stock_type',
    );
    const $stockTypeFields = $target.find('.stock_type_fields');
    const stockType = $target
      .find('#company_investee_investment_stock_type')
      .val();

    switch (status) {
      case 'exit':
        $statusExit.removeClass('d-none');
        $statusOtherExit.addClass('d-none');
        $changeLabelRound.text('売却時ラウンド');
        $changeLabelTran.text('売却日');
        $changeLabelTran.append($('<span class="required-mark">必須</span>'));
        $target
          .find('.company_investee_investments_sale_date')
          .find('input')
          .removeAttr('disabled');
        $target
          .find('.company_investee_investments_tran_on')
          .find('input')
          .attr('disabled', 'disabled');
        $target.find('.tran_on_fields').addClass('d-none');
        $target.find('.sale_date_fields').removeClass('d-none');
        $companyInvesteeInvestmentStockType.val('');
        $stockTypeFields.removeClass('d-flex').addClass('d-none');
        $stockTypeFields.find('select').attr('disabled', 'disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).removeAttr('disabled');
        });
        $statusOtherExit.find('input, textarea').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        break;
      case 'invested':
        $statusExit.addClass('d-none');
        $statusOtherExit.removeClass('d-none');
        $changeLabelRound.text('投資時ラウンド');
        $changeLabelTran.text('投資日');
        $changeLabelTran.append($('<span class="required-mark">必須</span>'));
        $target
          .find('.company_investee_investments_tran_on')
          .find('input')
          .removeAttr('disabled');
        $target
          .find('.company_investee_investments_sale_date')
          .find('input')
          .attr('disabled', 'disabled');
        $target.find('.tran_on_fields').removeClass('d-none');
        $target.find('.sale_date_fields').addClass('d-none');
        $stockTypeFields.removeClass('d-none').addClass('d-flex');
        $stockTypeFields.find('select').removeAttr('disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        if (stockType) {
          $statusOtherExit
            .children(`.${stockType}_fields`)
            .find('input')
            .each((i, element) => {
              $(element).removeAttr('disabled');
            });
        } else {
          $statusOtherExit.find('input').each((i, element) => {
            $(element).removeAttr('disabled');
          });
        }
        break;
      default:
        $statusExit.addClass('d-none');
        $statusOtherExit.removeClass('d-none');
        $changeLabelRound.text('投資時ラウンド');
        $changeLabelTran.text('投資日');
        $changeLabelTran.find('span').remove();
        $target
          .find('.company_investee_investments_tran_on')
          .find('input')
          .removeAttr('disabled');
        $target
          .find('.company_investee_investments_sale_date')
          .find('input')
          .attr('disabled', 'disabled');
        $target.find('.tran_on_fields').removeClass('d-none');
        $target.find('.sale_date_fields').addClass('d-none');
        $stockTypeFields.removeClass('d-none').addClass('d-flex');
        $stockTypeFields.find('select').removeAttr('disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        if (stockType) {
          $statusOtherExit
            .children(`.${stockType}_fields`)
            .find('input')
            .each((i, element) => {
              $(element).removeAttr('disabled');
            });
        } else {
          $statusOtherExit.find('input').each((i, element) => {
            $(element).removeAttr('disabled');
          });
        }
        break;
    }
  }

  @on({ event: 'change', selector: '.js-date_format' })
  onChangeDateFormat(e: any) {
    const date = e.target.value;
    $(e.target)
      .parents('fieldset')
      .find('.js-date_format')
      .val(date.replace(/(\d{4})\/(\d{2})\/\d{2}/, '$1年$2月'));
  }

  render() {
    maskInput();
    this.initDateRangePicker(this.$el);
    this.initUserCompanyOptions();
    this.disabledShowRemoveModalButton();
    this.initMemoFieldsOptions();
  }
}
